import { useTotemSectorActions } from '../TotemSector/useTotemSectorActions';
import { FinalizeService, TotemSectorMutationArgs } from '../../models';
import { useInboxActions } from '../Inbox/useInboxActions';

interface OnFinalizeAttentionParams {
  totemSectorBody: TotemSectorMutationArgs;
  finalizeServiceBody: FinalizeService;
}

const useFinalize = () => {
  const { onFinalizeService, isFinalizeServiceLoading } = useInboxActions();
  const { onFinalizeWithIssues, onFinalizeWithSuccess, isFinalizing } =
    useTotemSectorActions();

  const onFinalizeAttention = async ({
    totemSectorBody,
    finalizeServiceBody,
  }: OnFinalizeAttentionParams) => {
    const success = await onFinalizeService(finalizeServiceBody);
    if (!success) return;

    if (finalizeServiceBody.success) {
      await onFinalizeWithSuccess(totemSectorBody);
    } else {
      await onFinalizeWithIssues(totemSectorBody);
    }
    localStorage.removeItem('TOTEM_SECTOR_ID');
  };

  return {
    onFinalizeAttention,
    isFinalizing: isFinalizing || isFinalizeServiceLoading,
  };
};

export default useFinalize;
